import { resolveUploadUrl } from './api'

/** Normalize application CV field(s) into a list of upload paths. */
export function getApplicationCvFiles(appOrCv) {
  if (!appOrCv) return []

  if (typeof appOrCv === 'string') {
    return parseCvValue(appOrCv)
  }

  if (Array.isArray(appOrCv.cv_files) && appOrCv.cv_files.length) {
    return appOrCv.cv_files.map((item) => String(item || '').trim()).filter(Boolean)
  }

  return parseCvValue(appOrCv.cv)
}

function parseCvValue(cv) {
  if (cv == null) return []
  if (Array.isArray(cv)) {
    return cv.map((item) => String(item || '').trim()).filter(Boolean)
  }

  const raw = String(cv).trim()
  if (!raw) return []

  if (raw.startsWith('[')) {
    try {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) {
        return parsed.map((item) => String(item || '').trim()).filter(Boolean)
      }
    } catch {
      // Fall through to single path.
    }
  }

  return [raw]
}

export function getCvDisplayName(pathValue, index = 0) {
  const raw = String(pathValue || '').trim()
  if (!raw) return `File ${index + 1}`
  const base = raw.split('/').pop() || raw
  // Strip leading timestamp_random_ prefix when present: 171..._abc123_name.ext
  const cleaned = base.replace(/^\d+_[a-z0-9]+_/i, '')
  return cleaned || `File ${index + 1}`
}

export function isImageCvPath(pathValue) {
  return /\.(png|jpe?g|gif|webp)$/i.test(String(pathValue || ''))
}

export function mapCvFilesForDisplay(appOrCv) {
  return getApplicationCvFiles(appOrCv).map((pathValue, index) => ({
    path: pathValue,
    url: resolveUploadUrl(pathValue),
    name: getCvDisplayName(pathValue, index),
    isImage: isImageCvPath(pathValue),
  }))
}
